<template>
  <v-row>
    <v-card class="pa-0" v-if="flat" flat>
      <v-card-text class="py-0 background">
        <v-row>
          <v-col>
            <vue-query-builder v-model="queryObject" ref="vqb" :rules="queryMap" :labels="labels" :styled="true">
              <template v-slot:default="slotProps">
                <v-query-builder-group v-bind="slotProps" :query.sync="queryObject" />
              </template>
            </vue-query-builder>
          </v-col>
        </v-row>
        <v-row class="px-2">
          <v-col cols="4">
            <v-btn class="mr-2" @click="dialogSavedFilters=true" outlined color="secondary" small>Filtros guardados</v-btn>
          </v-col>
          <v-col cols="4">
            <v-btn class="mr-2" @click="dialogCreateFilter=true" :loading="$store.state.accounts.createLoader" color="primary" small>Guardar filtro</v-btn>
          </v-col>
          <v-col cols="4" class="text-right">
            <v-btn @click="buildQuery" color="primary" small>{{filterText}}</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-menu v-else :close-on-content-click="false" nudge-width="540" max-width="540" :nudge-bottom="10" offset-y left transition="slide-y-transition">
      <template v-slot:activator="{on}">
        <v-btn v-on="on" color="secondary" outlined retain-focus-on-click><v-icon left small>mdi-filter</v-icon>Filtrar <template v-if="queryObject.children && queryObject.children.length"> | {{queryObject.children.length}}</template></v-btn>
      </template>
      <v-card class="pa-0">
        <v-toolbar color="background" flat height="55">
          <v-toolbar-title class="body-1 text--secondary font-weight-medium">Filtros</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn class="mr-2" @click="dialogSavedFilters=true" outlined color="secondary" small>Ver guardados</v-btn>
              <v-btn @click="dialogCreateFilter=true" :loading="$store.state.accounts.createLoader" outlined color="secondary" small>Guardar filtro</v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <vue-query-builder v-model="queryObject" ref="vqb" :rules="queryMap" :labels="labels" :styled="true">
            <template v-slot:default="slotProps">
              <v-query-builder-group v-bind="slotProps" :query.sync="queryObject" />
            </template>
          </vue-query-builder>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-btn @click.stop="removeQuery" outlined color="secondary">Limpiar</v-btn>
          <v-spacer />
          <v-btn @click.stop="buildQuery" color="primary">{{filterText}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>

    <!-- dialog saved filters -->
    <v-dialog v-model="dialogSavedFilters" width="600" persistent no-click-animation>
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Seleccionar un filtro</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn class="ml-3" @click.stop="dialogSavedFilters=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-skeleton-loader v-if="$store.state.accounts.retrieveLoader" transition="fade-transition" type="list-item" />
          <v-simple-table v-else-if="filtersList.length">
            <template v-slot:default>
              <tbody>
                <tr v-for="(item, n) in filtersList" :key="n" @click="setFilter(item)" style="cursor: pointer">
                  <td>
                    <div class="d-flex">
                      <span class="body-1 text--secondary font-weight-medium">{{item.name}}</span>
                      <v-spacer />
                      <v-btn @click.stop="destroyFilter(n)" icon small color="red"><v-icon small>mdi-close</v-icon></v-btn>
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-row class="mx-0" v-else>
            <v-col class="py-2 text-center">
              <v-icon class="d-block" color="secondary" size="70">mdi-filter-variant</v-icon>
              <span class="d-block subtitle-1 my-2">Aún no tienes filtros guardados</span>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end dialog saved filters -->

    <!-- dialog create filter -->
    <v-dialog v-model="dialogCreateFilter" width="400" persistent no-click-animation>
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Guardar filtro</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn class="ml-3" @click.stop="dialogCreateFilter=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background-card">
          <v-list class="v-list-form py-6 transparent">
            <v-list-item>
              <v-list-item-title>Nombre</v-list-item-title>
              <v-list-item-subtitle>
                <v-text-field v-model="$v.newFilter.name.$model" :error="$v.newFilter.name.$error" placeholder="Escribe un nombre..." maxlength="56" background-color="white" outlined required single-line dense hide-details />
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="dialogCreateFilter=false" outlined color="secondary">Cancelar</v-btn>
          <v-btn @click="createFilter" :loading="$store.state.accounts.createLoader" color="primary">Guardar filtro</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog create filter -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import VueQueryBuilder from 'vue-query-builder'
import VQueryBuilderGroup from './VQueryBuilderGroup'
import ListViewMixin from '@/mixins/ListViewMixin'
export default {
  mixins: [
    ListViewMixin
  ],
  props: {
    queryMap: {
      type: Array,
      required: true
    },
    model: {
      type: String,
      required: true
    },
    flat: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    },
    filterText: {
      type: String,
      required: false,
      default () {
        return 'Filtrar'
      }
    }
  },
  components: {
    VueQueryBuilder,
    VQueryBuilderGroup
  },
  data () {
    return {
      queryObject: {
        logicalOperator: 'all',
        children: []
      },
      labels: {
        matchType: 'Match Type',
        matchTypes: [
          {
            id: 'all',
            label: 'Todos'
          }
        ],
        addRule: 'Agregar filtro',
        removeRule: '&times;',
        addGroup: 'Agregar grupo',
        removeGroup: '&times;',
        textInputPlaceholder: ''
      },
      operators: {
        contiene: '__icontains',
        'es menor a': '__lte',
        'es mayor a': '__gte',
        'es igual': ''
      },
      newFilter: {
        name: '',
        model: this.model
      },
      dialogSavedFilters: false,
      dialogCreateFilter: false
    }
  },
  computed: mapState({
    filtersCount: state => state.accounts.filtersCount,
    filtersList: state => state.accounts.filtersList
  }),
  created () {
    this.getFilters()
    if (this.$route.query !== {}) {
      this.setInitialQuery()
    }
  },
  methods: {
    getFilters () {
      const query = {
        model: this.model,
        limit: 0
      }
      this.$store.dispatch('accounts/LIST', {
        resource: 'filters',
        query: query
      })
    },
    buildQuery () {
      this.query = {}
      if (this.queryObject.children) {
        this.queryObject.children.forEach((d, i) => {
          if (d.query.operator) {
            this.query[`${d.query.rule}${this.operators[d.query.operator]}`] = d.query.value
          } else {
            this.query[`${d.query.rule}`] = d.query.value
          }
        })
      }
      this.setQuery()
    },
    setInitialQuery () {
      const initialQuery = {
        logicalOperator: 'All',
        children: []
      }
      Object.keys(this.$route.query).forEach((key) => {
        const operator = Object.values(this.operators).find(value => key.includes(value))
        const selectedOperator = Object.keys(this.operators).find(k => this.operators[k] === operator)
        const rule = key.replace(operator, '')
        const queryObject = this.queryMap.find(q => q.id === rule)
        if (queryObject) {
          initialQuery.children.push({
            type: 'query-builder-rule',
            query: {
              operand: queryObject.label,
              operator: selectedOperator,
              rule: rule,
              value: this.$route.query[key]
            }
          })
        }
        this.queryObject = initialQuery
      })
    },
    removeQuery () {
      this.$refs.vqb.query.children = []
    },
    setFilter (d) {
      this.queryObject = d.query_object
      this.dialogSavedFilters = false

      // run query filter
      this.buildQuery()
    },
    createFilter () {
      this.$v.newFilter.$touch()
      if (this.$v.newFilter.$invalid) {
        return false
      }
      this.newFilter.query_object = this.queryObject
      this.$store.dispatch('accounts/CREATE', {
        resource: 'filters',
        payload: this.newFilter
      })
      .then((response) => {
        this.dialogCreateFilter = false
      })
      .catch(() => {
        this.$dialog.message.error('Error al crear el filtro.')
      })
    },
    destroyFilter (i) {
      this.$store.dispatch('accounts/DESTROY', {
        resource: 'filters',
        id: this.filtersList[i].id
      })
      .catch(() => {
        this.$dialog.message.error('Error al eliminar el filtro.')
      })
    }
  },
  validations: {
    newFilter: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(56)
      }
    }
  }
}
</script>